import React from "react";

import alert from "./svg/alert";
import input from "./svg/input";

export const svgIcon = {
	registration: {
		company: ({ color = "#999999" }) => (
			<svg
				width="24"
				height="24"
				viewBox="0 0 98 79"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M48.9999 6.52873L4.57945 34.0383C3.17085 34.9107 1.32177 34.476 0.449418 33.0674C-0.422932 31.6587 0.0117894 29.8097 1.4204 28.9373L47.1571 0.612543L48.7313 3.15442L48.7347 3.15981M48.9999 6.52873L93.4204 34.0383C94.829 34.9107 96.6781 34.476 97.5504 33.0674C98.4228 31.6587 97.9881 29.8097 96.5795 28.9373L50.8427 0.612543L49.2685 3.15442L50.8427 0.612532C49.7137 -0.086666 48.2862 -0.0866629 47.1572 0.612533L48.7313 3.15442M15.3845 32.0488C17.0414 32.0488 18.3845 33.3919 18.3845 35.0488V73H37.1538V51.9512C37.1538 45.8761 42.0786 40.9512 48.1538 40.9512H49.8461C55.9212 40.9512 60.8461 45.8761 60.8461 51.9512V73H79.6153V35.0488C79.6153 33.3919 80.9585 32.0488 82.6153 32.0488C84.2722 32.0488 85.6153 33.3919 85.6153 35.0488V75C85.6153 77.2092 83.8244 79 81.6153 79H58.8461C56.6369 79 54.8461 77.2092 54.8461 75V51.9512C54.8461 49.1898 52.6075 46.9512 49.8461 46.9512H48.1538C45.3923 46.9512 43.1538 49.1898 43.1538 51.9512V75C43.1538 77.2092 41.3629 79 39.1538 79H16.3845C14.1754 79 12.3845 77.2092 12.3845 75V35.0488C12.3845 33.3919 13.7277 32.0488 15.3845 32.0488ZM49.2652 3.15981L49.2685 3.15442Z"
					fill={color}
				/>
			</svg>
		),
		phone: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				stroke="#999696"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
			</svg>
		),
		password: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				stroke="#999696"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
				<path d="M7 11V7a5 5 0 0 1 10 0v4" />
			</svg>
		),
		address: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				stroke="#999696"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
				<circle cx="12" cy="10" r="3" />
			</svg>
		),
		email: ({ color = "#999696" }) => (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				stroke={color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
				<polyline points="22,6 12,13 2,6" />
			</svg>
		),
		invoiceEmail: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 82 100"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M14.2607 32.6522C14.2607 30.9954 15.6039 29.6522 17.2607 29.6522H64.739C66.3959 29.6522 67.739 30.9954 67.739 32.6522C67.739 34.3091 66.3959 35.6522 64.739 35.6522H17.2607C15.6039 35.6522 14.2607 34.3091 14.2607 32.6522Z"
					fill="#999999"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M14.2607 18.3914C14.2607 16.7345 15.6039 15.3914 17.2607 15.3914H64.739C66.3959 15.3914 67.739 16.7345 67.739 18.3914C67.739 20.0482 66.3959 21.3914 64.739 21.3914H17.2607C15.6039 21.3914 14.2607 20.0482 14.2607 18.3914Z"
					fill="#999999"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M14.2607 46.9131C14.2607 45.2562 15.6039 43.9131 17.2607 43.9131H54.0434C55.7002 43.9131 57.0434 45.2562 57.0434 46.9131C57.0434 48.5699 55.7002 49.9131 54.0434 49.9131H17.2607C15.6039 49.9131 14.2607 48.5699 14.2607 46.9131Z"
					fill="#999999"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M74 6H8C6.89542 6 6 6.89543 6 7.99999V91.8261C6 92.9307 6.89543 93.8261 8 93.8261H74C75.1046 93.8261 76 92.9307 76 91.8261V8C76 6.89543 75.1046 6 74 6ZM8 0C3.58172 0 0 3.58171 0 7.99999V91.8261C0 96.2444 3.58172 99.8261 8 99.8261H74C78.4183 99.8261 82 96.2444 82 91.8261V8C82 3.58172 78.4183 0 74 0H8Z"
					fill="#999999"
				/>
				<path
					d="M27.9243 63.7153V85.0435H23.1489V63.7153H27.9243ZM40.6685 63.7153L32.3188 74.3794L27.4556 79.6528L26.5913 75.2144L29.7993 70.6147L34.8091 63.7153H40.6685ZM35.1313 85.0435L29.2427 75.3022L32.8755 72.4751L40.7856 85.0435H35.1313Z"
					fill="#999999"
				/>
				<path
					d="M42.2798 63.7153H50.4683C52.0991 63.7153 53.5103 63.9595 54.7017 64.4478C55.9028 64.936 56.8257 65.6587 57.4702 66.6157C58.1147 67.5728 58.437 68.7544 58.437 70.1606C58.437 71.3325 58.2466 72.3286 57.8657 73.1489C57.4849 73.9692 56.9478 74.6479 56.2544 75.1851C55.5708 75.7222 54.77 76.1567 53.8521 76.4888L52.2993 77.3384H45.3267L45.2974 73.6323H50.4829C51.1958 73.6323 51.7866 73.5054 52.2554 73.2515C52.7241 72.9976 53.0757 72.6411 53.3101 72.1821C53.5542 71.7134 53.6763 71.1665 53.6763 70.5415C53.6763 69.897 53.5542 69.3403 53.3101 68.8716C53.0659 68.4028 52.7046 68.0464 52.2261 67.8022C51.7573 67.5483 51.1714 67.4214 50.4683 67.4214H47.0552V85.0435H42.2798V63.7153ZM54.0864 85.0435L49.2964 75.5659L54.3354 75.5513L59.1987 84.8237V85.0435H54.0864Z"
					fill="#999999"
				/>
			</svg>
		),
		user: ({ color = "#999696" }) => (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				stroke={color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
				<circle cx="12" cy="7" r="4" />
			</svg>
		),
	},
	email: (
		<svg
			width="20"
			height="15"
			viewBox="0 0 20 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1 1L9.75 7.25L18.5 1M1 13.5H18.5V1H1V13.5Z"
				stroke="#6F6F6F"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	edit: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g id="edit-solid" clipPath="url(#clip0_1116_898)">
				<path
					id="Vector"
					d="M21.0274 0C20.2608 0 19.5098 0.297262 18.9309 0.876141L9.01173 10.764L8.7927 10.9831L8.73012 11.296L8.04172 14.8005L7.72881 16.2712L9.19948 15.9583L12.704 15.2699L13.0169 15.2073L13.236 14.9883L23.1239 5.0691C24.2777 3.91525 24.2777 2.02999 23.1239 0.876141C22.545 0.297262 21.794 0 21.0274 0ZM21.0274 1.94003C21.2621 1.94003 21.4928 2.06128 21.7158 2.28422C22.1617 2.73012 22.1617 3.21512 21.7158 3.66102L12.0156 13.3611L10.2947 13.7053L10.6389 11.9844L20.339 2.28422C20.5619 2.06128 20.7927 1.94003 21.0274 1.94003ZM0 3.97392V24H20.0261V10.7953L18.0235 12.7979V21.9974H2.00261V5.97653H11.2021L13.2047 3.97392H0Z"
					fill="#222222"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1116_898">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	),
	phone: (
		<svg
			width="30"
			height="26"
			viewBox="0 0 30 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M24.9307 6.06074L21.9628 3.35918C21.6006 3.0291 21.1157 2.84375 20.6029 2.84375C20.0901 2.84375 19.6052 3.02656 19.2429 3.35918L16.0465 6.26641C15.6842 6.59648 15.4808 7.04082 15.4808 7.50801C15.4808 7.97773 15.6814 8.41699 16.0465 8.74961L18.5435 11.0271C17.9746 12.2347 17.1573 13.3318 16.1357 14.2594C15.1129 15.1963 13.9174 15.9352 12.5909 16.4582L10.094 14.1807C9.73168 13.8506 9.24678 13.6652 8.73401 13.6652C8.48109 13.6644 8.23053 13.7095 7.99701 13.798C7.76349 13.8865 7.5517 14.0166 7.37406 14.1807L4.17485 17.0879C3.81257 17.418 3.60913 17.8623 3.60913 18.3295C3.60913 18.7992 3.80978 19.2385 4.17485 19.5711L7.13998 22.2727C7.75864 22.8363 8.61139 23.1588 9.48644 23.1588C9.66758 23.1588 9.84315 23.1461 10.0215 23.1182C13.7112 22.5646 17.373 20.7746 20.3298 18.0832C23.2838 15.3867 25.2457 12.0504 25.8587 8.68613C26.0343 7.73145 25.6832 6.74883 24.9307 6.06074ZM23.8829 8.38398C23.3395 11.3775 21.5727 14.3635 18.9113 16.7883C16.2499 19.2131 12.9755 20.8228 9.68988 21.318C9.27743 21.3814 8.85384 21.2545 8.55287 20.9828L5.64069 18.3295L8.72844 15.5137L12.067 18.5605L12.0921 18.5834L12.694 18.3803C14.5192 17.7689 16.1766 16.8032 17.5513 15.5502C18.9261 14.2972 19.9854 12.7867 20.6558 11.1236L20.8788 10.5752L17.5124 7.51055L20.6001 4.69473L23.5123 7.34805C23.8133 7.62227 23.9526 8.0082 23.8829 8.38398Z"
				fill="#6F6F6F"
			/>
		</svg>
	),
	password: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 15V17V15ZM6 21H18C18.5304 21 19.0391 20.7893 19.4142 20.4142C19.7893 20.0391 20 19.5304 20 19V13C20 12.4696 19.7893 11.9609 19.4142 11.5858C19.0391 11.2107 18.5304 11 18 11H6C5.46957 11 4.96086 11.2107 4.58579 11.5858C4.21071 11.9609 4 12.4696 4 13V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21ZM16 11V7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7V11H16Z"
				stroke="#6F6F6F"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	arrowRight: ({ light }) => (
		<svg
			width="10"
			height="9"
			viewBox="0 0 10 9"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M2.32348e-05 5.09705L8.11335 5.09705L4.38669 8.26297L5.33335 9.06152L10.6667 4.5307L5.33336 -0.000122537L4.39336 0.798435L8.11335 3.96435L2.33338e-05 3.96435L2.32348e-05 5.09705Z"
				fill={light ? "#fff" : "#333333"}
			/>
		</svg>
	),
	arrowLeft: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			stroke="#333"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<line x1="19" y1="12" x2="5" y2="12" />
			<polyline points="12 19 5 12 12 5" />
		</svg>
	),
	arrowLeftSmall: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
		>
			<path
				d="M4.46967 11.4697C4.32902 11.6103 4.25 11.8011 4.25 12C4.25 12.1989 4.32902 12.3897 4.46967 12.5303L8.96971 17.0303C9.2626 17.3232 9.73747 17.3232 10.0304 17.0303C10.3233 16.7374 10.3233 16.2626 10.0304 15.9697L6.81067 12.75H19C19.4142 12.75 19.75 12.4142 19.75 12C19.75 11.5858 19.4142 11.25 19 11.25H6.81067L10.0304 8.03033C10.3233 7.73744 10.3233 7.26257 10.0304 6.96967C9.73747 6.67678 9.2626 6.67678 8.9697 6.96967L4.46967 11.4697Z"
				fill="#23262A"
			/>
		</svg>
	),
	chevronDown: (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="32" height="32" rx="16" fill="#F5F5F5" />
			<path
				d="M9.14282 12.9524L16 19.8095L22.8571 12.9524"
				stroke="#222222"
				strokeWidth="1.14286"
			/>
		</svg>
	),

	chevronUp: (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="32"
				y="32"
				width="32"
				height="32"
				rx="16"
				transform="rotate(-180 32 32)"
				fill="#F5F5F5"
			/>
			<path
				d="M22.8572 19.0476L16 12.1905L9.14289 19.0476"
				stroke="#222222"
				strokeWidth="1.14286"
			/>
		</svg>
	),
	close: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
		>
			<path
				d="M5.41406 4.33594L4.33594 5.41406L10.9219 12L4.33594 18.5859L5.41406 19.6641L12 13.0781L18.5859 19.6641L19.6641 18.5859L13.0781 12L19.6641 5.41406L18.5859 4.33594L12 10.9219L5.41406 4.33594Z"
				fill="black"
			/>
		</svg>
	),
	refresh: (
		<svg
			fill="#222"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 30 30"
			width="20"
			height="20"
		>
			<path d="M 15 3 C 12.031398 3 9.3028202 4.0834384 7.2070312 5.875 A 1.0001 1.0001 0 1 0 8.5058594 7.3945312 C 10.25407 5.9000929 12.516602 5 15 5 C 20.19656 5 24.450989 8.9379267 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.437925 7.8516588 21.277839 3 15 3 z M 4 10 L 0 16 L 3.0507812 16 C 3.562075 22.148341 8.7221607 27 15 27 C 17.968602 27 20.69718 25.916562 22.792969 24.125 A 1.0001 1.0001 0 1 0 21.494141 22.605469 C 19.74593 24.099907 17.483398 25 15 25 C 9.80344 25 5.5490109 21.062074 5.0488281 16 L 8 16 L 4 10 z" />
		</svg>
	),
	wizardStep: {
		stepCompleted: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="20"
				height="20"
				fill="none"
				viewBox="0 0 24 24"
				stroke="currentColor"
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth={2}
					d="M5 13l4 4L19 7"
				/>
			</svg>
		),
	},
	welcome: {
		email: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="36"
				height="34"
				viewBox="0 0 36 34"
				fill="none"
			>
				<path
					d="M8.17582 17.5178C8.17582 15.1878 8.98168 13.1887 10.5934 11.5203C12.2344 9.85195 14.2271 9.01777 16.5714 9.01777C17.5971 9.01777 18.5201 9.16159 19.3407 9.44924C20.2784 9.76565 21.0256 10.2547 21.5824 10.9162V9.36294H24.967V22.1777C24.967 22.6667 25.1868 23.0981 25.6264 23.4721C26.0366 23.8173 26.5494 23.9898 27.1648 23.9898C28.63 23.9898 29.8755 23.2563 30.9011 21.7893C31.9267 20.3511 32.4396 18.5964 32.4396 16.5254C32.4396 12.901 31.033 9.79442 28.2198 7.20558C25.3773 4.64552 21.9634 3.36548 17.978 3.36548C13.9927 3.36548 10.5934 4.76057 7.78022 7.55076C4.96703 10.3409 3.56044 13.7208 3.56044 17.6904C3.56044 21.3435 4.96703 24.4501 7.78022 27.0102C10.5934 29.599 13.9927 30.8934 17.978 30.8934C19.8535 30.8934 21.5678 30.692 23.1209 30.2893C24.6447 29.8866 25.9194 29.3113 26.9451 28.5634L28.4835 31.3249C27.2234 32.1878 25.6996 32.8494 23.9121 33.3096C22.0952 33.7699 20.1172 34 17.978 34C13.0256 34 8.79121 32.4036 5.27472 29.2107C1.75824 26.0465 0 22.2064 0 17.6904C0 12.8003 1.75824 8.62944 5.27472 5.17766C8.79121 1.72589 13.0256 0 17.978 0C22.9597 0 27.2088 1.61083 30.7253 4.83249C34.2418 8.05415 36 11.9518 36 16.5254C36 19.5169 35.1355 22.0626 33.4066 24.1624C31.6777 26.291 29.5971 27.3553 27.1648 27.3553C25.7875 27.3553 24.5861 27.0389 23.5604 26.4061C22.5348 25.7445 21.9048 24.9103 21.6703 23.9036C21.1722 24.6514 20.4689 25.2411 19.5604 25.6726C18.652 26.1041 17.6557 26.3198 16.5714 26.3198C14.2271 26.3198 12.2344 25.4425 10.5934 23.6878C8.98168 21.9619 8.17582 19.9052 8.17582 17.5178ZM11.7802 17.5178C11.7802 18.956 12.2344 20.1929 13.1429 21.2284C14.0513 22.2927 15.1941 22.8249 16.5714 22.8249C17.978 22.8249 19.1648 22.2927 20.1319 21.2284C21.0989 20.1929 21.5824 18.956 21.5824 17.5178C21.5824 16.0795 21.0989 14.8426 20.1319 13.8071C19.1648 12.7716 17.978 12.2538 16.5714 12.2538C15.1941 12.2538 14.0513 12.786 13.1429 13.8503C12.2344 14.8858 11.7802 16.1083 11.7802 17.5178Z"
					fill="black"
				/>
			</svg>
		),
		vipps: (
			<svg
				width="64"
				height="16"
				viewBox="0 0 64 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M64 3.83838C63.2798 1.09082 61.5312 0 59.1445 0C57.2109 0 54.7842 1.09082 54.7842 3.71729C54.7842 5.41406 55.9565 6.74756 57.8691 7.09131L59.6797 7.41406C60.2642 7.51953 60.6504 7.6792 60.895 7.88477C61.0229 7.99219 61.1118 8.11182 61.1704 8.24268C61.2363 8.39062 61.2637 8.55273 61.2637 8.72754C61.2637 9.43457 60.5024 9.83838 59.3711 9.83838C57.8901 9.83838 56.9644 9.31348 56.8203 7.83838L54.208 8.24268C54.6191 11.0908 57.1699 12.2627 59.4736 12.2627C61.6548 12.2627 63.979 11.0103 63.979 8.48486C63.979 6.76758 62.9297 5.51514 60.9756 5.15137L58.9805 4.78809C57.8691 4.58594 57.499 4.04053 57.499 3.51514C57.499 2.84814 58.2192 2.42432 59.2065 2.42432C60.4614 2.42432 61.3462 2.84814 61.3872 4.24219L64 3.83838ZM5.9248 8.16113L8.64014 0.302734H11.8281L7.09668 11.9595H4.73145L0 0.302734H3.18848L5.9248 8.16113ZM22.6084 3.63623C22.6084 4.56543 21.8677 5.21191 21.0039 5.21191C20.1396 5.21191 19.3994 4.56543 19.3994 3.63623C19.3994 2.70654 20.1396 2.06055 21.0039 2.06055C21.8677 2.06055 22.6084 2.70654 22.6084 3.63623ZM23.1016 7.75781C22.0317 9.13135 20.9004 10.0811 18.9048 10.0811C16.8691 10.0811 15.2847 8.86865 14.0503 7.09131C13.5566 6.36377 12.7954 6.20215 12.2397 6.58594C11.7256 6.94971 11.6025 7.71729 12.0757 8.38428C13.7827 10.9497 16.1484 12.4443 18.9048 12.4443C21.4355 12.4443 23.4102 11.2324 24.9531 9.2124C25.5288 8.46484 25.5083 7.69727 24.9531 7.27295C24.4385 6.86865 23.6772 7.01074 23.1016 7.75781ZM30.2002 6.10059C30.2002 8.48486 31.5991 9.7373 33.1626 9.7373C34.6436 9.7373 36.166 8.56543 36.166 6.10059C36.166 3.67627 34.6436 2.50488 33.1831 2.50488C31.5991 2.50488 30.2002 3.61572 30.2002 6.10059ZM30.2002 1.91943V0.322754H27.2998V16H30.2002V10.4238C31.167 11.7168 32.4219 12.2627 33.8413 12.2627C36.4951 12.2627 39.0869 10.2021 39.0869 5.95947C39.0869 1.89844 36.3921 0 34.0879 0C32.2573 0 31.0024 0.828125 30.2002 1.91943ZM44.1274 6.10059C44.1274 8.48486 45.5264 9.7373 47.0898 9.7373C48.5708 9.7373 50.0933 8.56543 50.0933 6.10059C50.0933 3.67627 48.5708 2.50488 47.1104 2.50488C45.5264 2.50488 44.1274 3.61572 44.1274 6.10059ZM44.1274 1.91943V0.322754H41.2271V16H44.1274V10.4238C45.0942 11.7168 46.3491 12.2627 47.7686 12.2627C50.4224 12.2627 53.0142 10.2021 53.0142 5.95947C53.0142 1.89844 50.3193 0 48.0151 0C46.1846 0 44.9297 0.828125 44.1274 1.91943Z"
					fill="#ff5b24"
				/>
			</svg>
		),
	},
	clubCheck: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12C20.25 16.5563 16.5563 20.25 12 20.25C7.44365 20.25 3.75 16.5563 3.75 12ZM12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25ZM16.5725 9.48444C16.8401 9.16824 16.8007 8.695 16.4845 8.42745C16.1683 8.15989 15.695 8.19932 15.4275 8.51553L10.454 14.3933L8.03033 11.9697C7.73744 11.6768 7.26256 11.6768 6.96967 11.9697C6.67678 12.2625 6.67678 12.7374 6.96967 13.0303L9.96967 16.0303C10.118 16.1786 10.3216 16.2581 10.5312 16.2493C10.7407 16.2406 10.9371 16.1446 11.0725 15.9844L16.5725 9.48444Z"
				fill="#23262A"
			/>
		</svg>
	),
	tooltip: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
		>
			<path
				d="M10 1.875C5.52002 1.875 1.875 5.52002 1.875 10C1.875 14.48 5.52002 18.125 10 18.125C14.48 18.125 18.125 14.48 18.125 10C18.125 5.52002 14.48 1.875 10 1.875ZM10 3.125C13.8037 3.125 16.875 6.19629 16.875 10C16.875 13.8037 13.8037 16.875 10 16.875C6.19629 16.875 3.125 13.8037 3.125 10C3.125 6.19629 6.19629 3.125 10 3.125ZM9.375 6.25V7.5H10.625V6.25H9.375ZM9.375 8.75V13.75H10.625V8.75H9.375Z"
				fill="#222222"
			/>
		</svg>
	),
	...alert,
	...input,
};
